// The controller's 2220 and the hub firmware's 22208 identify the 4-port, 8-AO hub.
export function formatPhysicalIOLabel(id, devVariant) {
  const channel = Number(id);
  if (!Number.isInteger(channel) || channel < 0 || id == null || id === '') return '---';
  if ((Number(devVariant) === 2220 || Number(devVariant) === 22208) && channel < 8) {
    return `${Math.floor(channel / 2) + 1}.${(channel % 2) + 1}`;
  }
  return String(channel + 1);
}

export function getPhysicalIOLabel(controller, slaveAddress, id) {
  // Legacy Multi Out records already use one-based IDs.
  if (!controller.zones) return String(Number(id));
  const slave = Object.values(controller.slaves ?? {}).find(
    (entry) => String(entry.address) === String(slaveAddress)
  );
  return formatPhysicalIOLabel(id, slave?.dev_variant);
}
